"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountButton = AccountButton;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactGravatar = _interopRequireDefault(require("react-gravatar"));
var _AccountMenu = _interopRequireDefault(require("./AccountMenu"));
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var avatarSize = 24;
function AccountButton(_ref) {
  var email = _ref.email,
    onSignOut = _ref.onSignOut;
  var _a, _b, _c;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var tenantId = (_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id;
  var assistingTo = access === null || access === void 0 ? void 0 : access.assisting_to;
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    assistant = _useState4[0],
    setAssistant = _useState4[1];
  var onBecomeAssistant = function onBecomeAssistant(assistant) {
    setOpen(false);
    setAssistant(assistant);
  };
  var closePromise = (0, _react.useCallback)(function () {
    var _a;
    var userId = (_a = assistingTo === null || assistingTo === void 0 ? void 0 : assistingTo.user) === null || _a === void 0 ? void 0 : _a.id;
    var id = assistingTo === null || assistingTo === void 0 ? void 0 : assistingTo.id;
    if (tenantId && userId && id && (assistingTo === null || assistingTo === void 0 ? void 0 : assistingTo.type) === 'platform') {
      return (0, _api.deleteAssistant)(tenantId, userId, id, {
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, access, assistingTo]);
  var onCloseAssistant = function onCloseAssistant() {
    feedbackContext.showBackdrop();
    closePromise().then(function () {
      (0, _api.endAssistantSession)();
      if ((assistingTo === null || assistingTo === void 0 ? void 0 : assistingTo.type) === 'platform') {
        window.location.href = process.env.REACT_APP_ADMIN_URL;
      } else {
        window.location.href = "/t/".concat(tenantId);
      }
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var onContinue = function onContinue() {
    if (!access || !access.tenant) return;
    if (!assistant) return;
    (0, _api.beginAssistantSession)(assistant);
    setAssistant(undefined);
    window.location.href = "/t/".concat(access.tenant.id);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    ref: anchorRef,
    "aria-haspopup": "true",
    edge: "end",
    color: "inherit",
    size: "small",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    sx: {
      width: avatarSize,
      height: avatarSize
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactGravatar["default"], {
    email: email,
    size: avatarSize,
    "default": "wavatar"
  }))), open && /*#__PURE__*/_react["default"].createElement(_AccountMenu["default"], {
    anchorRef: anchorRef,
    onBecomeAssistant: onBecomeAssistant,
    onCloseAssistant: onCloseAssistant,
    onClose: function onClose() {
      return setOpen(!open);
    },
    onSignOut: onSignOut
  }), assistant && /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    open: true,
    title: (0, _core.translate)('assistants.change_to.title'),
    maxWidth: "sm",
    fullWidth: true,
    button: {
      text: (0, _core.translate)('buttons.continue'),
      onClick: onContinue
    },
    onClose: function onClose() {
      return setAssistant(undefined);
    }
  }, (0, _core.translate)('assistants.change_to.text', {
    name: (_c = (_b = assistant.user) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '---'
  })));
}